<header class="export-bcf-dialog__header">
  <b>{{ 'bcf-export-form.export-bcf' | translate }}</b>
</header>

<section class="export-bcf-dialog">
  <form class="export-bcf-dialog__form" #exportBcfForm="ngForm">
    <div class="export-bcf-dialog__field">
      <span class="export-bcf-dialog__label" id="format-label">{{
        'bcf-export-form.select-format' | translate
      }}</span>
      <hlm-radio-group
        class="export-bcf-dialog__radio-group"
        aria-labelledby="format-label"
        [ngModel]="selectedFormat()"
        (ngModelChange)="selectedFormat.set($event)"
        name="format"
        required
      >
        <div class="export-bcf-dialog__radio">
          <hlm-radio inputId="bcf-format-2-1" value="2.1">
            <hlm-radio-indicator indicator />
          </hlm-radio>
          <label hlmLabel for="bcf-format-2-1">BCF 2.1</label>
        </div>
        <div class="export-bcf-dialog__radio">
          <hlm-radio inputId="bcf-format-3-0" value="3.0">
            <hlm-radio-indicator indicator />
          </hlm-radio>
          <label hlmLabel for="bcf-format-3-0">BCF 3</label>
        </div>
      </hlm-radio-group>
    </div>
    <div class="export-bcf-dialog__actions">
      <button
        hlmBtn
        type="button"
        class="export-bcf-dialog__export-btn"
        [disabled]="exportBcfForm.invalid"
        (click)="onExport()"
      >
        <ocp-themed-icon name="checkmark.svg" mode="dark" />
        {{ 'bcf-export-form.export-bcf-btn' | translate }}
      </button>
      <button
        hlmBtn
        type="button"
        variant="secondary"
        class="export-bcf-dialog__cancel-btn"
        (click)="onCancel()"
      >
        <ocp-themed-icon name="cross.svg" />
        {{ 'bcf-export-form.cancel' | translate }}
      </button>
    </div>
  </form>
</section>
